const PRODUCTION_API_URL = 'https://api.allasercenter.com';

function isBrowser() {
  return typeof window !== 'undefined' && Boolean(window.location);
}

function currentOrigin() {
  return isBrowser() ? window.location.origin : '';
}

export function apiBaseUrl() {
  const configured = String(process.env.REACT_APP_API_URL || '').trim();
  const browserOrigin = currentOrigin();

  if (configured) return configured.replace(/\/+$/, '');
  if (browserOrigin) return `${browserOrigin}/api`;
  return PRODUCTION_API_URL;
}

export function publicBaseUrl() {
  return apiBaseUrl().replace(/\/api\/?$/, '');
}

export function storageUrl(pathValue) {
  const trimmed = String(pathValue || '').trim();
  if (!trimmed) return '';
  if (/^(https?:|data:|blob:)/i.test(trimmed)) return trimmed;

  const cleanPath = trimmed.replace(/^\/+/, '');
  if (cleanPath.startsWith('storage/')) {
    return `${publicBaseUrl()}/${cleanPath}`;
  }

  return `${publicBaseUrl()}/storage/${cleanPath}`;
}

export function logoUrl(pathValue, fallback = '/lazer.png') {
  const trimmed = String(pathValue || '').trim();
  if (!trimmed) return fallback;
  if (trimmed.startsWith('/')) return trimmed;
  return storageUrl(trimmed) || fallback;
}
